export default {
  SettingOrderSourceDeploy: {
    tab1: '寻源失败设置',
    tab2: '分配物流',
    sourcing: '寻源失败处理',
    stockOut: '缺货',
    reSource: '重新寻源',
    manual: '人工处理',
    resourceInterval: '重新寻源间隔',
    resources: '重新寻源次数',
    resourcesText: '请选择重新寻源次数',
    secondRate: '次',
    resourcesFail: '重新寻源失败处理',
    tabTitle: 'WMS支持按分配物流发货',
    sourcingText: '请选择寻源失败处理',
    resourceIntervalText: '请输入重新寻源间隔',
    resourcesFailText: '请选择重新寻源失败处理',
  }
};
